import {observer} from 'mobx-react';
import React from 'react';
import {
  X1LanguageSelect,
  X2AgeCategorySelect,
  X3LevelSelect,
  X4UnitSelect
} from '../../../../lib/components';
import {X4UnitStore} from '../X4UnitStore';

@observer
export class MoveLessonForm extends React.Component<{ store: X4UnitStore }> {
  render() {
    const {store} = this.props;

    if (store.move === null)
      return null;

    const move = store.move;

    return (
      <div className="row" key="move-form">
        <div className="col-3">
          <div className={move.language.formGroupClassName}>
            <X1LanguageSelect options={move.languageOptions}
                              value={move.language.value}
                              onChange={move.language.setValue}
                              onBlur={move.language.markTouched}/>
            <div className="invalid-text">Enter language</div>
          </div>
        </div>
        <div className="col-3">
          <div className={move.ageCategory.formGroupClassName}>
            <X2AgeCategorySelect options={move.ageCategoryOptions}
                                 value={move.ageCategory.value}
                                 onChange={move.ageCategory.setValue}
                                 onBlur={move.ageCategory.markTouched}/>
            <div className="invalid-text">Enter age category</div>
          </div>
        </div>
        <div className="col-3">
          <div className={move.level.formGroupClassName}>
            <X3LevelSelect options={move.levelOptions}
                           value={move.level.value}
                           onChange={move.level.setValue}
                           onBlur={move.level.markTouched}/>
            <div className="invalid-text">Enter level</div>
          </div>
        </div>
        <div className="col-3">
          <div className={move.unit.formGroupClassName}>
            <X4UnitSelect options={move.unitOptions}
                          value={move.unit.value}
                          onChange={move.unit.setValue}
                          onBlur={move.unit.markTouched}/>
            <div className="invalid-text">Enter unit</div>
          </div>
        </div>
      </div>
    );
  }
}
